import { createStyles, Theme } from '@material-ui/core/styles';

import { colors } from '@shared/theme/colours';
export const navMenuWidth = 210;
export const navMenuWidthCollapsed = 24;
export const workspaceSelectorWidth = 56;

export const styles = ({ spacing, zIndex }: Theme) =>
  createStyles({
    root: {},

    sideBarRoot: {
      height: '100%',
      minHeight: 640,
      position: 'fixed',
      width: navMenuWidth,
      zIndex: zIndex.appBar,
    },
    sidebarNav: {
      width: navMenuWidth,
      transition: 'all 0.3s ease',
    },
    sidebarWorspaces: {
      height: '100%',
      width: workspaceSelectorWidth,
    },
    sideNavigationCollapsed: {
      width: navMenuWidthCollapsed,
    },
    collapsed: {
      width: navMenuWidthCollapsed,
    },
    app: {
      backgroundColor: colors.grey.body,
      minHeight: '100vh',
      zIndex: 1,
    },
    appNotFullScreen: {
      height: 'auto',
      marginLeft: navMenuWidth,
      transition: 'all 0.3s ease',
    },
    appNotFullScreenWorkspaces: {
      marginLeft: navMenuWidth + workspaceSelectorWidth,
    },
    appFullScreen: {},
    appCollapsed: {
      marginLeft: navMenuWidthCollapsed,
    },
    sidebarWithWorkspaces: {
      width: navMenuWidth + workspaceSelectorWidth,

      '&$collapsed': {
        width: navMenuWidthCollapsed + workspaceSelectorWidth,
      },

      '& $sideBarRoot': {
        left: workspaceSelectorWidth,
      },
    },
    appCollapsedWithWorskpaces: {
      marginLeft: navMenuWidthCollapsed + workspaceSelectorWidth,
    },

    appNoTransition: {
      transition: 'none',
    },
    toasts: {
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(2),
      justifyContent: 'flex-end',
      left: 0,
      margin: spacing(2),
      overflowY: 'auto',
      position: 'fixed',
      width: 400,
      zIndex: 10000,
    },
  });
